import React from "react";

export default class ForumSection extends React.Component {
    render() {
        let { title, catalogs, actions } = this.props;
        return (
            <div className='pubhub-forum'>
                <div className='container'>
                    <div className='pubhub-forum-header'>
                        <div className='pubhub-forum-title'>
                            {title}
                        </div>
                    </div>
                    <div className='pubhub-forum-catalogs'>
                        {this.renderCatalogs(catalogs)}
                    </div>
                    <div className='pubhub-forum-footer'>
                        {this.renderActions(actions)}
                    </div>
                </div>
            </div>
        );
    }

    renderCatalogs(catalogs) {
        if (!catalogs || catalogs.length == 0) {
            return null;
        }

        return (
            <div className='row'>
                {
                    catalogs.map((catalog, idx) => this.renderCatalog(catalog, idx))
                }
            </div>
        );
    }

    renderCatalog(catalog, key) {
        let className = catalog.tech ? (' pubhub-forum-tech-' + catalog.tech) : '';
        return (
            <div key={key} className='col-sm-6 col-lg-4'>
                <a className={'pubhub-forum-catalog-box' + className}
                    href={this.buildUrl(catalog.href)} target='_blank' rel="noopener noreferrer">
                    <div className={'pubhub-forum-catalog'}>
                        <div className='pubhub-forum-catalog-title'>{catalog.title}</div>
                        <div className='pubhub-forum-catalog-description'>{catalog.description}</div>
                    </div>
                </a>
            </div>
        );
    }

    renderActions(actions) {
        if (!actions) {
            return;
        }
        return (
            <div className='pubhub-forum-actions'>
                {
                    actions.viewAll ? (
                        <a className='btn btn-lg-wide btn-primary' href={this.props.baseUrl}>
                            {actions.viewAll}
                        </a>
                    ) : null
                }
                {
                    actions.spark ? (
                        <a className='btn btn-lg-wide btn-primary-outline' href='/site/spark-chat'>
                            <span className='pubhub-btn-icon'></span>
                            <span>{actions.spark}</span>
                        </a>
                    ) : null
                }
            </div>
        );
    }

    buildUrl(href = '') {
        return href.startsWith('http') ? href : this.props.baseUrl + href;
    }
}